import React, {useEffect, useState} from 'react';

import {Header} from '../../../components/Interface/Headers/Header';

import {
  Container,
  Content,
  SectionScroll,
} from './styles';

import {Titles} from '../../../components/Interface/Typographies/Titles';
import {ReembolsoSolicitacao} from '../../../dtos/ReembolsoDTO';

import {RootStackParamList} from '../../../dtos/RoutesDTO';
import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {AcompanhaReembolso} from '../../../components/shared/Reembolsos/AcompanhaReembolso';
import {api} from '../../../services/api';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import { useAuth } from '../../../context/auth';
import { SafeAreaView } from 'react-native-safe-area-context';
import { NotFound } from '../../../components/Interface/Search/NotFound';
import { RFPercentage } from 'react-native-responsive-fontsize';

type ScreenProps = NativeStackScreenProps<
  RootStackParamList,
  'PedidosReembolso'
>;

export function PedidosReembolso({navigation}: ScreenProps) {
  const [compras, setCompras] = useState([] as ReembolsoSolicitacao[]);
  const [isLoading, setIsLoading] = useState(false);
  const {isLogged} = useAuth();

  function toTimestamp(dateString?: string | null) {
    if (!dateString) {
      return 0;
    }

    if (dateString.includes('T')) {
      const parsed = Date.parse(dateString);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    const normalized = dateString.replaceAll('-', '/').trim();
    const ymdMatch = normalized.match(/^(\d{4})\/(\d{2})\/(\d{2})/);
    if (ymdMatch) {
      const [, y, m, d] = ymdMatch;
      const parsed = Date.parse(`${y}-${m}-${d}`);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    const dmyMatch = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
    if (dmyMatch) {
      const [, d, m, y] = dmyMatch;
      const parsed = Date.parse(`${y}-${m}-${d}`);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    const fallback = Date.parse(normalized);
    return Number.isNaN(fallback) ? 0 : fallback;
  }

  useEffect(() => {
    if (!isLogged) {
      navigation.navigate('Home');
    }
  }, [isLogged]);

  useEffect(() => {
    async function fetchCompras() {
      try {
        setIsLoading(true);

        const response = await api.get('/reembolsoSolicitado');

        const sorted = [...response.data].sort((a, b) => {
          return toTimestamp(b.data_solicitacao) - toTimestamp(a.data_solicitacao);
        });

        setCompras(sorted);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchCompras();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (  
        compras.length > 0 ? (
        <SafeAreaView edges={['bottom']} style={{flex: 1}}>
        <Container>
          <Header
            icon="chevron-left"
            action={() => navigation.navigate('Reembolsos')}
            parentHelp
          />
          <Content>
            <Titles
              title="Acompanhe o status do seu reembolso"
              subtitle="Veja o andamento da sua solicitação em tempo real."
            />

            <SectionScroll showsVerticalScrollIndicator={false}>
              {compras &&
                compras.length > 0 &&
                compras.map((item, index) => (
                  <AcompanhaReembolso
                    key={index}
                    index={index}
                    data={{
                      ...item,
                    }}
                  />
                ))}
            </SectionScroll>
          </Content>
        </Container>
        </SafeAreaView>
        )
        : (
          <>
           <Header icon="chevron-left" action={() => navigation.goBack()} />
          <NotFound title='Não existem pedidos' text='Você não possui pedidos de reembolso no momento.' style={{marginTop: -RFPercentage(5)}}/>
        </>
        )
      )}
    </>
  );
}
